module.exports = __webpack_public_path__ + "static/media/QRAnimation.5b0705f2.mp4";